import Vue from 'vue';
import Vuex from 'vuex';

import { calendar } from './modules/calendar';
import { community } from './modules/community';
import { file } from './modules/file';
import { post } from './modules/post';
import { tools } from './modules/tools';
import { user } from './modules/user';
import { talk } from './modules/talk';
import { video } from './modules/video';
import { viewer } from './modules/viewer';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    calendar: calendar,
    community: community,
    file: file,
    post: post,
    tools: tools,
    user: user,
    talk: talk,
    video: video,
    viewer: viewer,
  },
});
